export const DEMO_STATUSES = [
  ["new", "New"], ["contacted", "Contacted"], ["demo_scheduled", "Demo Scheduled"],
  ["demo_completed", "Demo Completed"], ["trial", "Trial / Evaluation"],
  ["converted", "Converted"], ["not_interested", "Not Interested"],
];
export const DEMO_STATUS_LABEL = Object.fromEntries(DEMO_STATUSES);

export const ACCOUNT_STATUSES = [
  ["active", "Active"], ["trial", "Trial"], ["past_due", "Past Due"],
  ["suspended", "Suspended"], ["canceled", "Canceled"],
];
export const ACCOUNT_STATUS_LABEL = Object.fromEntries(ACCOUNT_STATUSES);

export const PLANS = [["core", "Core"], ["pro", "Pro"]];
export const PLAN_LABEL = { core: "Core", pro: "Pro", dealer: "Core", dealer_pro: "Pro", dealer_enterprise: "Pro" };

export const ACCESS_TYPES = [
  ["paid", "Paid"], ["complimentary", "Complimentary"], ["trial", "Trial"], ["admin_override", "Admin Override"],
];
export const ACCESS_TYPE_LABEL = Object.fromEntries(ACCESS_TYPES);

export const ASSESS_STATUSES = [
  ["anonymous", "Anonymous"], ["identified", "Identified"], ["assessment_emailed", "Assessment Emailed"],
  ["demo_requested", "Demo Requested"], ["demo_scheduled", "Demo Scheduled"],
];
export const ASSESS_STATUS_LABEL = Object.fromEntries(ASSESS_STATUSES);

export const OPP_LEVELS = [
  ["well_positioned", "Well Positioned"], ["moderate", "Moderate Opportunity"], ["strong", "Strong Opportunity"],
  ["high", "High Opportunity"], ["very_high", "Very High Opportunity"],
];
export const OPP_LEVEL_LABEL = Object.fromEntries(OPP_LEVELS);

export const levelBadge = (l) => ({
  well_positioned: "bg-emerald-50 text-emerald-700 border-emerald-200",
  moderate: "bg-sky-50 text-sky-700 border-sky-200",
  strong: "bg-amber-50 text-amber-700 border-amber-200",
  high: "bg-orange-50 text-orange-700 border-orange-200",
  very_high: "bg-red-50 text-red-700 border-red-200",
}[l] || "bg-slate-100 text-slate-600 border-slate-200");

export const statusBadge = (s) => ({
  anonymous: "bg-slate-100 text-slate-600 border-slate-200",
  identified: "bg-blue-50 text-blue-700 border-blue-200",
  assessment_emailed: "bg-cyan-50 text-cyan-700 border-cyan-200",
  demo_requested: "bg-purple-50 text-purple-700 border-purple-200",
  new: "bg-blue-50 text-blue-700 border-blue-200",
  contacted: "bg-amber-50 text-amber-700 border-amber-200",
  demo_scheduled: "bg-purple-50 text-purple-700 border-purple-200",
  demo_completed: "bg-teal-50 text-teal-700 border-teal-200",
  trial: "bg-indigo-50 text-indigo-700 border-indigo-200",
  converted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  not_interested: "bg-slate-100 text-slate-500 border-slate-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  past_due: "bg-amber-50 text-amber-700 border-amber-200",
  suspended: "bg-red-50 text-red-700 border-red-200",
  canceled: "bg-slate-100 text-slate-500 border-slate-200",
}[s] || "bg-slate-100 text-slate-600 border-slate-200");

export const fmtDate = (d) => { if (!d) return "-"; try { return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); } catch { return d; } };
export const fmtDateTime = (d) => { if (!d) return "-"; try { return new Date(d).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return d; } };

export const nfmt = (n) => (n == null ? "-" : Number(n).toLocaleString("en-US"));
export const usd = (n) => { if (n == null) return "-"; const v = Number(n); if (v === 0) return "$0.00"; return "$" + (v >= 1 ? v.toFixed(2) : v.toFixed(4)); };
export const credits = (n) => (n == null ? "-" : Number(n).toLocaleString("en-US", { maximumFractionDigits: 3 }) + " cr");
